import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default function LeaveJobDialog({ open, onLeave, onStay }) {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "#161B22",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "16px",
          m: 2,
          maxWidth: "340px",
          width: "100%",
        },
      }}
    >
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "1rem", mb: 1 }}>
          Leave this job?
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: "0.875rem", lineHeight: 1.5 }}>
          The job stays open. You can resume it from Home.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onStay}
          variant="outlined"
          fullWidth
          sx={{
            color: "#fff",
            borderColor: "rgba(255,255,255,0.2)",
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": {
              borderColor: "rgba(255,255,255,0.4)",
              backgroundColor: "rgba(255,255,255,0.05)",
            },
          }}
        >
          Stay
        </Button>
        <Button
          onClick={onLeave}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#FDB940",
            color: "#000",
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            "&:hover": { backgroundColor: "#e5a830" },
          }}
        >
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
}
